import stringify from 'json-stringify-safe';

export default class DumpUtils
{
    static json(data){
        console.log(stringify(data, undefined, 4));
        return data;
    }

    static error(error){
        if(error.response.contentType.indexOf('text/html')>=0){
            var newError = Object.assign({}, error);
            newError.response.data = 'SUPERFLOUS ASP.NET ERROR PAGE HTML REMOVED';
        }
        console.log('DUMP_ERROR:\n', stringify(error, undefined, 4));
    }

    static errorLight(error) {
        var resp = error.response;
        var message = error.toString();
        if (resp.data && resp.data.message) {
            message = resp.data.message;
        }
        console.log(' ======================================================================================');
        console.log(' *** [%s - %s] [%s]', resp.status, resp.statusText, message);
        console.log(' *** [%s] %s', error.request.method.toUpperCase(), error.request.url);
        console.log(' ======================================================================================');
    }

    static errorHeavy(error){
        console.log('DUMP_ERROR_HEAVY:\n', stringify(error, undefined, 4));
    }

    static getAuthBrief(authHeader){
        if (authHeader) {
            var start = 0, end = authHeader.length-1;
            if (end < 30) {
                return authHeader
            }
            return authHeader.substr(0,15) + '...' + authHeader.substr(end-15, end);
        }
    }


    static simple(resp) {
        // console.log('dumpSimple resp', resp);
        var dumpArray = [];
        const C = resp.config, H = resp.config.headers;
        dumpArray.push(` HTTP REQUEST [${C.method.toUpperCase()}] ${C.url}`);
        dumpArray.push(`   Authorization: [${DumpUtils.getAuthBrief(H.Authorization)}]`);
        dumpArray.push(`   Accept: [${H.Accept}]`);
        dumpArray.push(' -------------------------------------------------------------------');
        dumpArray.push(` HTTP RESPONSE Status: [${resp.status}] ${resp.statusText}`);
        dumpArray.push(`   Content: ${resp.headers['content-type']} [${resp.headers['content-length']}]`);
        var dataString = stringify(resp.data, undefined, 4);
        var dataArray = dataString.split('\n').map(s => '   ' + s);
        dumpArray = dumpArray.concat(dataArray).map(s => '| ' + s);
        dumpArray.unshift('======================================================================');
        dumpArray.push('======================================================================');
        const dumpString = dumpArray.map(s => '         ' + s).join('\n')
        console.log(dumpString);
        return resp;
    }
}





// WEBPACK FOOTER //
// ./src/Utils/DumpUtils.js


// WEBPACK FOOTER //
// webpack:///src/Utils/DumpUtils.js